/***********************************************************
 Polyfills
 --------------------------
 Here, we define all fallback functions that are used by the app
 or the vendors but some browsers do not support them.
 ************************************************************/
if (!Math.cbrt) {
    Math.cbrt = function (x) {
        let y = Math.pow(Math.abs(x), 1 / 3);
        return x < 0 ? -y : y;
    };
}